import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.achievements.list');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-achievements-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.achievements.list/view.scss */
/* src/app/portal.achievements.list/view.scss: no such file or directory */`],
})
export class PortalAchievementsListComponent implements OnInit {
    @Input() data!: ProductData;
    @Input() period: any;

    public categories = [
        { key: 'all', label: '전체', count: 0 },
        { key: 'paper', label: '논문', count: 0 },
        { key: 'patent', label: '특허', count: 0 },
        { key: 'report', label: '보고서', count: 0 },
    ];

    public category: string = 'all';
    public products = [];
    public sliceProducts = [];
    public page_size = 10;
    public maxlen = 10;
    public list: any;

    public page = {
        current: 1,
        start: 1,
        end: 1,
    };

    private async move(index: number) {
        this.page.current = index;
        await this.load();
    }

    public statusClass = {
        'paper': 'bg-blue-100 text-blue-600',
        'report': 'bg-pink-100 text-pink-600',
        'patent': 'bg-green-100 text-green-600',
    };

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.load();
        await this.service.render();
    }

    public async ngOnChanges(changes: SimpleChanges) {

        if (changes['period'] && !changes['period'].firstChange) {
            await this.load();
            await this.service.render();
        }
    }

    public async load() {   
        
        this.data = (this.data ?? []).map((p: any) => {
            let coauthor: string | null = null;

            if (p.kr_coauth) coauthor = p.kr_coauth.replace(/;/g, ", ");
            else if (p.en_coauth) coauthor = p.en_coauth.replace(/;/g, ", ");

            return {
                ...p,
                coauthor: coauthor
            };
        });

        //순서 년도 기준 내림차순
        this.data = (this.data ?? []).sort((a: any, b: any) => {
            const yearA = Number(a.pub_year);
            const yearB = Number(b.pub_year);
            const idA = Number(a.id);
            const idB = Number(b.id);

            // 1️⃣ 둘 다 pub_year 있으면 → pub_year 내림차순
            if (!isNaN(yearA) && !isNaN(yearB)) {
                return yearB - yearA;
            }

            // 2️⃣ 한쪽만 pub_year 없으면 → 없는 쪽이 뒤로
            if (isNaN(yearA)) return 1;
            if (isNaN(yearB)) return -1;

            // 3️⃣ 둘 다 pub_year 없으면 → id 기준 오름차순
            return idA - idB;
        });
        const start = Number(this.period.start);
        const end = Number(this.period.end);

        this.list = this.data;
        this.list = (this.list ?? []).filter((p: any) => {
            const y = Number(p.pub_year);
            return y >= start && y <= end;
        });
        this.products = this.list;

        //개수 
        if (Array.isArray(this.list)) {
            const counts: Record<string, number> = this.list.reduce((acc, item) => {
                const cat = item.category || 'etc';
                acc[cat] = (acc[cat] || 0) + 1;
                return acc;
            }, {} as Record<string, number>);

            this.categories = this.categories.map(cat => ({
                ...cat,
                count: cat.key === 'all' ? this.list.length : (counts[cat.key] || 0),
            }));

            await this.service.render();
        }
        
        this.recalcPages();
        await this.service.render();
    }

    public setCategory(c) {
        this.category = c;

        if (c === 'all') this.products = this.list ?? [];
        else this.products = (this.list ?? []).filter((p: any) => p.category === c);

        this.page.current = 1;
        this.recalcPages();
        this.service.render();
    }

    public async goScienceON(p) {
        let url = '';
        if (p.category === 'report') {
            url = `https://scienceon.kisti.re.kr/srch/selectPORSrchReport.do?cn=${p.doc_num}`;
        }
        else if (p.category === 'paper') {
            url = `https://scienceon.kisti.re.kr/srch/selectPORSrchArticle.do?cn=${p.doc_num}`;
        }
        else if (p.category === 'patent') {
            url = `https://scienceon.kisti.re.kr/srch/selectPORSrchPatent.do?cn=${p.doc_num}`;
        }
        window.open(url, '_blank');
    }

    getlabel(key: string): string {
        return this.categories.find(c => c.key === key)?.label || key;
    }

    //pagenation
    private recalcPages() {
        const totalItems = this.products.length;
        this.page.end = Math.max(1, Math.ceil(totalItems / this.page_size));
        if (this.page.current > this.page.end) this.page.current = this.page.end;

        this.page.start = Math.floor((this.page.current - 1) / this.maxlen) * this.maxlen + 1;
        this.applyPage(); // 현재 페이지 슬라이스 반영
    }

    private applyPage() {
        const startIdx = (this.page.current - 1) * this.page_size;
        const endIdx = startIdx + this.page_size;
        this.sliceProducts = this.products.slice(startIdx, endIdx);
    }

    public async move(index: number) {
        // 경계 보정
        let p = Number(index) || 1;
        if (p < 1) p = 1;
        if (p > this.page.end) p = this.page.end;

        this.page.current = p;
        this.page.start = Math.floor((p - 1) / this.maxlen) * this.maxlen + 1;

        this.applyPage();
        await this.service.render();
    }


}

export default PortalAchievementsListComponent;